// extracted by mini-css-extract-plugin
export default {"actionLink":"qqqxkFkwrKMR4HYjFfYb"};